import React, { useRef } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getTranslations } from "../data/translations/index";
import { useReveal } from "../hooks/useReveal";
import { Icon } from "./icons";
import "../styles/ExpertiseItem.css";

export const ExpertiseItem = () => {
  const { language } = useLanguage();
  const { Expertise } = getTranslations(language);
  const rootRef = useRef(null);
  useReveal(rootRef, language);

  return (
    <div className="expertise-list container" ref={rootRef}>
      {Expertise.map((category, index) => (
        <section
          key={category.category}
          className="expertise-card glass glass--interactive"
          data-reveal
          style={{ "--reveal-delay": `${Math.min(index, 4) * 0.06}s` }}
        >
          <h2 className="expertise-card__title">{category.category}</h2>
          <ul className="expertise-skills">
            {category.skills.map((skill) => (
              <li key={skill.name} className="expertise-skill">
                <span className="expertise-skill__head">
                  <Icon name={skill.icon} className="expertise-skill__icon" />
                  <span className="expertise-skill__name">{skill.name}</span>
                </span>
                {skill.level && (
                  <span className="expertise-skill__level">{skill.level}</span>
                )}
                {skill.details && (
                  <span className="expertise-skill__details">
                    {skill.details.join(", ")}
                  </span>
                )}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};
